import clsx from 'clsx';
import { BlueArrowIcon } from '@/features/shared/Icons';
import React, { BaseSyntheticEvent, useMemo } from 'react';
import { mapLinkToProps } from '@/utils/helpers';

import { INavigationDropdownItemProps } from '../../../PortalNavigation.interfaces';

import useNavigationDropdownItemStyles from './MenuItem.styles';
import { MuiButtonBase, MuiTypography } from '@/features/shared/material-ui';

const MenuItem = ({
  children,
  navigationItem,
  onItemClick,
  isActive = false,
  arrowIconDirection = 'right',
  hoverDisabled = false,
  id,
}: React.PropsWithChildren<INavigationDropdownItemProps>) => {
  const classes = useNavigationDropdownItemStyles();
  const linkProps = useMemo(() => mapLinkToProps(navigationItem.link), [navigationItem.link]);
  const { onClick: onClickLinkProps, ...restLinkProps } = linkProps;
  const hasChildren = navigationItem?.navigationItems && navigationItem?.navigationItems.length > 0;

  const onItemClicked = React.useCallback(
    (event: BaseSyntheticEvent<any, any, any>) => {
      if (onClickLinkProps) onClickLinkProps();
      if (onItemClick) {
        onItemClick(event);
      }
    },
    [onClickLinkProps, onItemClick],
  );

  return (
    <div className={classes.wrapper}>
      <MuiButtonBase
        id={id}
        className={clsx([
          classes.root,
          {
            hovered: !hoverDisabled,
            isActive,
          },
        ])}
        {...(hasChildren ? {} : restLinkProps)}
        data-navigation-dropdown-item
        onClick={onItemClicked}
      >
        <span className="navigation-item-text-content">
          <MuiTypography className={classes.dropdownItemLabel} component="span">
            {navigationItem?.link?.displayText}
          </MuiTypography>
          <div>
            <BlueArrowIcon
              direction={arrowIconDirection}
              className={clsx(hasChildren ? classes.visible : classes.hidden, classes.arrowIcon)}
            />
          </div>
        </span>
      </MuiButtonBase>
      {children}
    </div>
  );
};

export default MenuItem;
